import websiteImg from '~/assets/images/cross-sell/WeddingWebsite.png';

import { CrossSellCard } from './CrossSellCard';

import styles from './crossSellWebsite.module.less';

export const WEBSITE_HREF = '/wedding/manage/website/designs';

export const CrossSellWebsite = ({ handleClick }: { handleClick: () => void }) => {
  const preview = <img src={websiteImg} alt="" className={styles.staticImage} />;
  return (
    <CrossSellCard
      hed="While you’re here, start your free wedding website"
      cta="Explore designs"
      href={WEBSITE_HREF}
      onClick={handleClick}
      className={styles.crossSellWebsite}
      preview={preview}
    />
  );
};

export default CrossSellWebsite;
